import isLoading from './is-loading'
import addError from './add-error'
import removeMfaFactor from '@app/request/remove-mfa-factor'
import { removedMfaFactor } from '@app/reducer/me'

export default (params) => {
  return async (dispatch) => {
    dispatch(isLoading('remove-mfa'))
    const result = await removeMfaFactor(params)
    if (result.error) {
      dispatch(addError(result.error))
    }
    if (result === true) {
      dispatch(removedMfaFactor(params.type))
    }

    dispatch(isLoading('remove-mfa', true))
    return result
  }
}
